export default {
	title: "Journey Stages",
	name: "Name",
	description: "Description",
	createStage: "Create Journey Stage",
	createSuccess: "Journey stage created successfully!",
	updateSuccess: "Journey stage updated successfully!",
	deleteSuccess: "Journey stage deleted successfully!",
	deleteError: "Error deleting journey stage",
	category: {
		label: "Category",
		MEDIUNICA: "Mediumship",
		RITUALISTICA: "Ritualistic",
		FORMACAO: "Education",
	},
	requiredStage: "Prerequisite",
	requiredStageHint: "Milestone the person must have completed first",
	associatedPeople: "Mediums in: {name}",
	confirmDeleteAssignment: "Are you sure you want to unlink {person} from the journey \"{stage}\"?",
	confirmDeleteMessage: "Are you sure you want to delete the journey \"{name}\"? This action cannot be undone.",
	confirmDeleteWithPeopleMessage: "The journey \"{name}\" still has linked mediums. Do you want to delete it anyway? The links will be removed as well.",
	empty: {
		description: "Register the spiritual development stages of your temple",
		title: "No mediumship journey found",
	},
	hasAssociatedPeopleDetailed: "There are {active} active link(s) and {inactive} inactive link(s) in this journey. Unlink them before deleting.",
	noAssociatedPeople: "No mediums linked to this journey",
	order: "Order",
	stats: {
		avgPerStage: "Avg/Stage",
		totalPeople: "People",
		totalStages: "Stages",
	},
	viewActiveAssociated: "View active",
};
